
import React from 'react';

const FooterLogoSection = () => (
  <div className="flex flex-col items-start space-y-6">
    <img
      src="/lovable-uploads/a24b420b-3da0-4f29-8ab0-51a4f33f1e45.png"
      alt="ALTA-X Logo"
      className="w-32 drop-shadow-lg brightness-0 invert"
    />
    <p className="text-sm text-blue-100 leading-relaxed max-w-sm">
      <span className="font-bold text-white">ALTA-X</span> is South Africa's premier platform for alternative investments, empowering you to diversify your portfolio with exclusive assets and expert insights in a secure, regulated environment.
    </p>
  </div>
);

export default FooterLogoSection;
